<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.folder") }}</h2>
    </div>
    <div
      class="col-lg-2 tooltip-wrapper pointer"
      @click="$router.go(-1)"
      style="float: right; cursor: pointer"
    >
      <span class="tooltip-wrapper pointer" style="float: right">
        <i class="fa fa-times close"></i>
        <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="row">
          <div class="col-lg-12">
              <!-- <div class="ibox-content py-2 style_2 d-flex justify-content-end align-items-center mb-2">
                
                <div
                  class="position-relative"
                  v-if="roleprivileges.includes('Documents Upload Document')"
                >
                  <img
                    class="cursor-pointer"
                    src="../../assets/img/upload_files.png"
                    alt="upload document"
                    @click="enablepopup('update')"
                  />
                  <div class="tool-tip">
                    {{ $t("navigations.upload documents") }}
                  </div>
                </div>
              </div> -->
              
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-1 mr-0 pr-0">
        <div class="ibox-body">
          <div class="ibox-title style_2 d-flex justify-content-between">
            <h5>{{ $t("navigations.folder list") }}</h5>
         
          </div>
          <div class="ibox-content overflow-y-block">
            <div v-if="showTreeLoading == true" class="text-center">
              <img src="" alt="" />
              <div>
                {{
                  $t(
                    "navigations.please wait while the tree is being generated"
                  )
                }}
              </div>
              <img
                src="../../assets/img/loading.gif"
                width="15"
                alt="Waiting for login"
              />
            </div>
            <div v-else id="primary-tmf-tree">
              <ul
                v-if="folderlist.length != 0"
                v-on:clickout="clickedOut($event)"
              >
                <TreeWithNewpopup
                   v-if="folderlist.length != 0"
                  :list="folderlist"      
                  :restoreOnMount="true"  
                  :openfolderlist="openfolderlist"        
                  @reloadFolders="getTree()"
                  @editFolder="editFolder()"
                  @addFolder="createFolderfunc('addSubFolder',$event)"
                  @deleteFolder="deleteFolder($event)"
                  @archiveFolder="archiveFolder()"
                  @cloneFolder="openCloneFolder($event)"
                  @exportFolder="exportFolder($event)"
                  @addFolderPermission="addFolderPermission($event)"
                  @shareFolderPermission="shareFolderPermission()"
                  @uploadDocument="openDocumentModal()"
                  @emptyChild="returnChild($event)"
                  @exportFolderTreeStructure="exportTreeFolderStructure($event)"
                  @folderType="returnFolderType($event)"
                  @selectedfoldertype="selectedtype($event)"
                  patid=""
                  :boldfolder ="`${bold}`"
                >
                </TreeWithNewpopup>
              </ul>
              <div class="text-center p-5" v-else>
                <img
                  width="70"
                  src="../../assets/img/EmptyFolder.svg"
                  alt="No folder available"
                />
                <h4 class="my-3">
                  {{
                    $t(
                      "navigations.no tree data found for this study please add a folder"
                    )
                  }}
                </h4>
                <button
                  type="button"
                  @click="createFolderfunc('addRoot')"
                  class="save_btn py-1 px-3 position-relative"
                >
                  <p class="mb-0">
                    {{ $t("navigations.add folder") }}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="ibody">
          <div class="ibox-title style_2 d-flex justify-content-between px-3">
            <h5>{{ $t("navigations.documents") }}</h5>
            <button
              v-if="$store.getters.getFolderId"
              class="position-relative border-0 align-self-center p-0"
              @click.prevent="enablepopup('etmf')"
            >
              <img
                class="cursor-pointer"
                src="../../assets/img/create.png"
                alt="Add a file"
                width="20"
                height="20"
              />
              <span class="tool-tip">{{
                $t("navigations.add documents")
              }}</span>
            </button>
          </div>
          <div class="ibox-content scrollable-block" id="primaryDocumentTree">
            <div class="text-center" v-if="showTableLoading">
              <div>
                {{
                  $t("navigations.please wait while the list is being loaded")
                }}
              </div>
              <img
                src="../../assets/img/loading.gif"
                width="15"
                alt="Waiting for login"
              />
            </div>
            <div v-else class="table-responsive">
              <table
                v-if="documentList.length != 0"
                class="table table-bordered"
              >
                <thead>
                  <tr>
                    <th>Document File Name</th>
                    <th>Document Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(document, index) in documentList"
                    :key="document.id"
                  >
                    <td class="align-items-center fixed-width-table-cell">
                      <div
                        class="cursor-pointer"
                        @click.prevent="
                          viewDocument(
                            document.id,
                            document.name,
                            document.latestVersion
                          )
                        "
                        v-if="
                          document && document.name && document.name.length < 41
                        "
                      >
                        {{ document.name }}
                      </div>
                      <div v-else>
                        <div v-if="!readMore[index]" class="breakWord">
                          <span
                            class="cursor-pointer"
                            @click.prevent="
                              viewDocument(
                                document.id,
                                document.name,
                                document.latestVersion
                              )
                            "
                            >{{
                              document.name
                                ? document.name.substring(0, 40)
                                : ""
                            }}</span
                          >
                          <span
                            @click="showMore(index)"
                            v-if="!readMore[index]"
                            class="cursor-pointer more-block"
                            >...More</span
                          >
                        </div>
                        <div v-if="readMore[index]" class="breakWord">
                          <span
                            class="cursor-pointer"
                            @click.prevent="
                              viewDocument(
                                document.id,
                                document.name,
                                document.latestVersion
                              )
                            "
                            >{{ document.name }}
                          </span>
                          <span
                            @click="showLess(index)"
                            v-if="readMore[index]"
                            class="cursor-pointer less-block"
                            >...Less</span
                          >
                        </div>
                      </div>
                    </td>
                    <td class="align-items-center fixed-width-table-cell">
                      <div
                        class="cursor-pointer"
                        @click.prevent="
                          viewDocument(
                            document.id,
                            document.name,
                            document.latestVersion
                          )
                        "
                        v-if="
                          document &&
                          document.documentTitle &&
                          document.documentTitle.length < 20
                        "
                      >
                        {{ document.documentTitle }}
                      </div>
                      <div v-else>
                        <div v-if="!readTitleMore[index]" class="breakWord">
                          <span
                            class="cursor-pointer"
                            @click.prevent="
                              viewDocument(
                                document.id,
                                document.name,
                                document.latestVersion
                              )
                            "
                          >
                            {{
                              document.documentTitle
                                ? document.documentTitle.substring(0, 20)
                                : ""
                            }}</span
                          >
                          <span
                            class="cursor-pointer more-block"
                            @click="showTitleMore(index)"
                            v-if="
                              !readTitleMore[index] && document.documentTitle
                            "
                            >...More</span
                          >
                        </div>
                        <div v-if="readTitleMore[index]" class="breakWord">
                          <span
                            class="cursor-pointer"
                            @click.prevent="
                              viewDocument(
                                document.id,
                                document.name,
                                document.latestVersion
                              )
                            "
                          >
                            {{ document.documentTitle }}
                          </span>
                          <span
                            class="cursor-pointer less-block"
                            @click="showTitleLess(index)"
                            v-if="readTitleMore[index]"
                            >Less</span
                          >
                        </div>
                      </div>
                    </td>
                    <td class="text-center" width="40">
                      <button
                        class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-3 py-0"
                        :popovertarget="`tmf-docs-` + document.id"
                        :anchor="`tmf-docs-` + document.id"
                        @click="openSidePopup(document.id)"
                      >
                        <i class="fa fa-ellipsis-v"></i>
                      </button>
                      <div
                        :id="`tmf-docs-` + document.id"
                        popover
                        class="tmf-docs-popup-menu"
                      >
                        <div
                          class="text-center p-2 w-100"
                          v-if="showDocLoading[document.id]"
                        >
                          <img
                            src="../../assets/img/loading.gif"
                            width="15"
                            alt="Waiting for login"
                          />
                        </div>

                        <template v-else>
                          <div
                            v-if="anyuserpermissions == false"
                            class="pointer-none px-2 py-3"
                          >
                            Nothing to show
                          </div>
                          <button
                            v-if="archiveValue"
                            class="popup-menu-block text-start"
                            @click.prevent="
                              archiveDocument(
                                `tmf-docs-` + document.id,
                                document.id,
                                document.name,
                                document.latestVersion.versionId
                              )
                            "
                          >
                            Archive
                          </button>
                          <button
                            v-if="editValue"
                            class="popup-menu-block text-start"
                            @click.prevent="
                              editDocument(
                                document.id,
                                `tmf-docs-` + document.id,
                                document.latestVersion.versionId
                              )
                            "
                          >
                            Edit
                          </button>
                          <button
                            v-if="downloadValue"
                            class="popup-menu-block text-start"
                            @click.prevent="
                              downloadDocument(
                                document.id,
                                `tmf-docs-` + document.id,
                                document.name
                              )
                            "
                          >
                            Download
                          </button>
                          <button
                            v-if="deleteValue"
                            class="popup-menu-block text-start"
                            @click.prevent="
                              deleteDocument(
                                document.id,
                                `tmf-docs-` + document.id
                              )
                            "
                          >
                            Delete
                          </button>
                          <button
                            v-if="permissionsValue"
                            class="popup-menu-block text-start"
                            @click.prevent="
                              addFolderPermission(
                                'File',
                                `tmf-docs-` + document.id,
                                document.id
                              )
                            "
                          >
                            Permission
                          </button>
                          <button
                            v-if="shareValue"
                            class="popup-menu-block text-start"
                            @click.prevent="
                              shareFolderPermission(
                                'File',
                                `tmf-docs-` + document.id,
                                document.id
                              )
                            "
                          >
                            Share
                          </button>
                          <button
                            v-if="viewValue"
                            class="popup-menu-block text-start"
                            @click.prevent="
                              viewDocument(
                                document.id,
                                document.name,
                                `tmf-docs-` + document.id
                              )
                            "
                          >
                            View
                          </button>
                        </template>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center p-5" v-else>
                <img
                  width="50"
                  src="../../assets/img/EmptyFile.svg"
                  alt="No file available"
                />
                <h4 class="my-3" v-if="$store.getters.getFolderId == ''">
                  {{
                    $t(
                      "navigations.no documents found please choose a folder to list documents"
                    )
                  }}
                </h4>
                <h4 class="my-3" v-else>
                  {{
                    $t(
                      "navigations.no documents found for this folder please add a document"
                    )
                  }}
                </h4>
                <button
                  v-if="$store.getters.getFolderId"
                  type="button"
                  @click="enablepopup('etmf')"
                  class="save_btn py-1 px-3 position-relative"
                >
                  <p class="mb-0">
                    {{ $t("navigations.add documents") }}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Popup library -->

  <AddApproverLibrary
    v-if="popactive"
    :id="documentPopupId"
    :versionId="PopupVersionId"
    :versionNumber="PopupVersionNumber"
    @libactive="popactive = false"
    @listupdate="getDocuments()"
  >
  </AddApproverLibrary>

  <listApproverPopup
    v-if="popupmodal"
    :id="documentPopupId"
    :versionId="PopupVersionId"
    :versionNumber="PopupVersionNumber"
    @libactive="popupmodal = false"
    @listupdate="getDocuments()"
  >
  </listApproverPopup>

  <!-- Popup library -->

  <!-- <div class="create-folder-modal" v-if="showFolder == true">
    <div class="folder-modal-container">
      <div class="title-class d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.create folder") }}</h4>
        <div class="cursor-pointer" @click="onclosed('addFolder')">
          <i class="fa fa-times"></i>
        </div>
      </div>
      <div class="ibox-content p-4">
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Folder Name"
            class="form-control"
            v-model="values.FolderName"
            maxlength="1000"
          />
          <span class="input-group-append">
            <button
              type="button"
              class="btn btn-primary save_btn"
              @click="addFolder()"
            >
              {{ $t("navigations.add") }}
            </button>
          </span>
        </div>
        <span class="errorClass" v-if="errors[0] == false">{{
          $t("navigations.please enter a folder name")
        }}</span>
      </div>
    </div>
  </div> -->

  <!-- popup ends -->

  <DocumentPopup
    v-if="uploadpopupmodal"
    :id="documentPopupId"
    :refid="doceditid"
    :versId="docverId"
    :artifactId="artifactId"
    :docdesc="Description"
    :editorupdate="calldetails"
    :documentType="documentType"
    :siteCode="siteCode"
    @uploadlibactive="uploadmethodactivity()"
    :documentName="documentName"
  >
  </DocumentPopup>
  <teleport to="#app">
    <div class="blank-wrapper" v-if="initialPermissionLoader == true">
      <div class="text-center">
        <h2>{{ `Please wait..` }}</h2>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>
    </div>
    <div class="blank-wrapper" v-if="initialLoader == true">
      <div class="text-center">
        <h2 v-if="initialLoader == true">
          {{ `Please wait while the folder is being ${process}` }}
        </h2>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>
    </div>
    <div class="blank-wrapper" v-if="initialDocDownloader == true">
      <div class="text-center">
        <h2>{{ `Please wait while the document is being downloaded` }}</h2>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>
    </div>
    <div class="blank-wrapper" v-if="initialTreeDownloader == true">
      <div class="text-center">
        <h2>{{ `Please wait while the tree structure is being exported` }}</h2>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>
    </div>
  </teleport>
  <customModal
    v-if="showFolder == true"
    :containersm="true"
    @closeModal="addFolderModalClose"
  >
    <template #title>
      {{ $t("navigations.add folder") }}
    </template>
    <template #body>
      <label for="designation"
        >Folder Name<sup><i class="fa fa-asterisk field-validation"></i></sup
      ></label>
      <input
        placeholder="Enter folder name"
        type="text"
        class="form-control"
        v-model="folderbyid.name"
        maxlength="75"
      />
      <span class="errorClass" v-if="editFolderErrors[0] == true"
        >{{folderErrorMessages[0]}}
      </span>
      <div class="mt-2">
        <label for="folderType"
          >Enter Type<sup><i class="fa fa-asterisk field-validation"></i></sup
        ></label>
        <input
          id="folderType"
          type="text"
          class="form-control"
          :disabled="isEditable == false"
          v-model="folderType"
          maxlength="75"
        />
        <span class="errorClass" v-if="editFolderErrors[1] == true"
          >Please enter a folder type
        </span>
      </div>
      

      <div class="form-group mb-0 mt-3 d-flex justify-content-center">
        <button
          type="button"
          class="save_btn py-1 px-4 mr-2 position-relative"
          @click="addFolder()"
          :class="{ 'disabled-btn-cls': loadingEditFolder == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingEditFolder == false,
              'opacity-1': loadingEditFolder == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <p
            class="mb-0"
            :class="{
              'opacity-1': loadingEditFolder == false,
              'opacity-0': loadingEditFolder == true,
            }"
          >
            {{ $t("navigations.add") }}
          </p>
        </button>
      </div>
    </template>
  </customModal>
  <customModal
    v-if="editFolderModal == true"
    :containersm="true"
    @closeModal="editFolderModalClose"
  >
    <template #title>
      {{$t("navigations.edit folder")}}
    </template>
    <template #body>
      <label for="folderName"
        >Enter Folder Name<sup
          ><i class="fa fa-asterisk field-validation"></i></sup
      ></label>
      <input
        type="text"
        id="folderName"
        class="form-control"
        v-model="folderbyid.name"
        maxlength="75"
      />
      <span class="errorClass" v-if="editFolderErrors[0] == true"
        >Please enter a folder name
      </span>
      <div class="mt-2">
        <label for="folderType"
          >Enter Type <sup><i class="fa fa-asterisk field-validation"></i></sup
        ></label>
        <input
          id="folderType"
          type="text"
          class="form-control"
          v-model="folderType"
          maxlength="75"
        />
        <span class="errorClass" v-if="editFolderErrors[1] == true"
          >Please enter a folder type
        </span>
      </div>
      <div class="row mt-3">
       
        <div class="col-12 text-center">
          <button
            type="button"
            class="save_btn py-1 px-3 position-relative"
            :disabled="loadingEditFolder == true"
            @click.prevent="updatefolder(folderbyid.name, folderType)"
            :class="{ 'disabled-btn-cls': loadingEditFolder == true }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': loadingEditFolder == false,
                'opacity-1': loadingEditFolder == true,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <p
              class="mb-0"
              :class="{
                'opacity-1': loadingEditFolder == false,
                'opacity-0': loadingEditFolder == true,
              }"
            >
              {{ $t("navigations.save") }}
            </p>
          </button>
        </div>
      </div>
    </template>
  </customModal>
  <customModal
    v-if="cloneFolderModal == true"
    :containersm="true"
    @closeModal="cloneFolderModalClose"
  >
    <template #title>
      {{ $t("navigations.clone folder") }}
    </template>
    <template #body>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mb-2">
            <label class="mb-0 mr-1" for="cloneType">{{
              $t("navigations.choose action to clone")
            }}</label>
            <span class="field-validation">*</span>
            <select id="cloneType" class="form-select" v-model="cloneType">
              <option selected value="">None</option>
              <option value="folderonly">Only Folder</option>
              <option value="folderpermission">Folders and permission</option>
              <option value="folderfilepermission">
                Folder,permission and files
              </option>
            </select>
          </div>
          <div class="col-12 mb-2">
            <label class="mb-0 mr-1" for="newFolderName">{{
              $t("navigations.folder name")
            }}</label>
            <input
              class="form-control"
              id="newFolderName"
              v-model="newFolderName"
            />
          </div>
          <div class="overflow-y-modal">
            <label class="mb-0" for="folderLocation">{{
              $t("navigations.choose target")
            }}</label>
            <ul v-if="folderlist.length != 0">
              <TreeMove
                v-if="folderlist.length != 0"
                :list="folderlist"
                patid=""
                :boldfolder="`${bold}`"
              >
              </TreeMove>
            </ul>
          </div>
        </div>
      </div>
      <div class="modal-footer pb-0">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="save_btn py-1 px-3 position-relative"
            :disabled="loadingCloneFolder == true"
            @click.prevent="cloneFolder()"
            :class="{ 'disabled-btn-cls': loadingCloneFolder == true }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': loadingCloneFolder == false,
                'opacity-1': loadingCloneFolder == true,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <p
              class="mb-0"
              :class="{
                'opacity-1': loadingCloneFolder == false,
                'opacity-0': loadingCloneFolder == true,
              }"
            >
              {{ $t("navigations.clone") }}
            </p>
          </button>
        </div>
      </div>
    </template>
  </customModal>

  <customModal
    v-if="openFileShareModal == true"
    :containermd="true"
    :footerShow="true"
    @closeModal="closeShareFolderPermission('File')"
  >
    <template #title>
      {{ $t("navigations.document share") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
          <label class="">Choose Role</label>
          <select
            class="form-select"
            name="account"
            @change="onChange($event, documentIdd)"
          >
            <option value="" disabled selected>-Select-</option>
            <option v-for="role in roleList" :key="role.id" :value="role.id">
              <span>
                {{ role.role_Name }}
              </span>
            </option>
          </select>
        </div>
      </div>
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
                <input type="checkbox" id="selectall" @change="selectall()" />
                Name
              </th>
              <th v-for="permissions in permissionList" :key="permissions.id">
                <input
                  type="checkbox"
                  :id="permissions.permission"
                  @change="setpermissions(permissions.permission)"
                />
                {{ permissions.permission }}
              </th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="options in userList" :key="options.id">
              <td>
                <input
                  type="checkbox"
                  :value="options.name"
                  :id="options.userID"
                  :checked="userobject[options.userID].permission.length != 0"
                  @change="setcontrols(options)"
                />
                {{ options.name }}
              </td>
              <td v-for="option in permissionList" :key="option.id">
                <input
                  type="checkbox"
                  :value="option.permission"
                  :class="options.id"
                  v-model="userobject[options.userID].permission"
                  @change="selectuserwithpermission(options.userID)"
                />
                {{ option.permission }}
              </td>
              <td class="text-center">
                <button
                  @click="saveSinglePermission('file', options.userID)"
                  class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative"
                  type="button"
                  :disabled="loadingPermission[options.userID] == true"
                  :class="{
                    'disabled-btn-cls':
                      loadingPermission[options.userID] == true,
                  }"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': loadingPermission[options.userID] == false,
                      'opacity-1': loadingPermission[options.userID] == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <p
                    class="mb-0"
                    :class="{
                      'opacity-1': loadingPermission[options.userID] == false,
                      'opacity-0': loadingPermission[options.userID] == true,
                    }"
                  >
                    {{ $t("navigations.save") }}
                  </p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between"
        v-if="selectedRole.length != 0 && userList.length != 0"
      >
        <p class="my-0">
          *Unsaved changes will be lost if switching designations.
        </p>
        <button
          type="button"
          @click="multiSaveShare('File')"
          class="save_btn py-1 px-3 position-relative"
          :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingSaveModalBtn == false,
              'opacity-1': loadingSaveModalBtn == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <p
            class="mb-0"
            :class="{
              'opacity-1': loadingSaveModalBtn == false,
              'opacity-0': loadingSaveModalBtn == true,
            }"
          >
            {{ $t("navigations.share") }}
          </p>
        </button>
      </div>
    </template>
  </customModal>
  <customModal
    v-if="openFileViewModal == true"
    :dynamicbodyxl="true"
    :containerxl="true"
    @closeModal="closeViewDocumentModal()"
  >
    <template #title>
      {{ $t("navigations.document view") }}
    </template>
    <template #body>
      <h4>{{ documentName }}</h4>
      <div v-if="format == 'JPG' || format == 'JPEG'">
        <img :src="source" alt="Italian Trulli" class="imgwidth" />
      </div>
      <div v-if="format == 'pdf'" class="pdfembeded">
        <vue-pdf-embed :source="source" />
      </div>
      <div v-if="office.includes(format)" class="outsideframe">
        <iframe
          :src="officeurl"
          width="100%"
          height="650px"
          frameborder="0"
        ></iframe>
      </div>
    </template>
  </customModal>
  <customModal
    v-if="openFolderShareModal == true"
    :containermd="true"
    :footerShow="true"
    @closeModal="closeShareFolderPermission()"
  >
    <template #title>
      {{ $t("navigations.folder share") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
          <label class="">Choose Role</label>
          <select class="form-select" name="account" @change="onChange($event)">
            <option value="" disabled selected>-Select-</option>
            <option v-for="role in roleList" :key="role.id" :value="role.id">
              <span>
                {{ role.role_Name }}
              </span>
            </option>
          </select>
        </div>
      </div>
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
                <input type="checkbox" id="selectall" @change="selectall()" />
                Name
              </th>
              <th v-for="permissions in permissionList" :key="permissions.id">
                <input
                  type="checkbox"
                  :id="permissions.permission"
                  @change="setpermissions(permissions.permission)"
                />
                {{ permissions.permission }}
              </th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="options in userList" :key="options.id">
              <td>
                <input
                  type="checkbox"
                  :value="options.name"
                  :id="options.userID"
                  :checked="userobject[options.userID].permission.length != 0"
                  @change="setcontrols(options)"
                />
                {{ options.name }}
              </td>
              <td v-for="option in permissionList" :key="option.id">
                <input
                  type="checkbox"
                  :value="option.permission"
                  :class="options.id"
                  v-model="userobject[options.userID].permission"
                  @change="selectuserwithpermission(options.userID)"
                />
                {{ option.permission }}
              </td>
              <td class="text-center">
                <button
                  @click="saveSinglePermission('folder', options.userID)"
                  class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative"
                  type="button"
                  :disabled="loadingPermission[options.userID] == true"
                  :class="{
                    'disabled-btn-cls':
                      loadingPermission[options.userID] == true,
                  }"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': loadingPermission[options.userID] == false,
                      'opacity-1': loadingPermission[options.userID] == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <p
                    class="mb-0"
                    :class="{
                      'opacity-1': loadingPermission[options.userID] == false,
                      'opacity-0': loadingPermission[options.userID] == true,
                    }"
                  >
                    {{ $t("navigations.save") }}
                  </p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between"
        v-if="selectedRole.length != 0 && userList.length != 0"
      >
        <p class="my-0">
          *Unsaved changes will be lost if switching designations.
        </p>
        <button
          type="button"
          @click="multiSaveShare('Folder')"
          class="save_btn py-1 px-3 position-relative"
          :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingSaveModalBtn == false,
              'opacity-1': loadingSaveModalBtn == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <p
            class="mb-0"
            :class="{
              'opacity-1': loadingSaveModalBtn == false,
              'opacity-0': loadingSaveModalBtn == true,
            }"
          >
            {{ $t("navigations.share") }}
          </p>
        </button>
      </div>
    </template>
  </customModal>
  <customModal
    v-if="openDocsPermissionModal == true"
    :containermd="true"
    :footerShow="true"
    @closeModal="permissionModalClose('File')"
  >
    <template #title>
      {{ $t("navigations.document permission") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
          <label class="">Designations</label>
          <Multiselect
            name="designation"
            valueProp="id"
            mode="multiple"
            placeholder="Select"
            :options="roleList"
            :hideSelected="false"
            :closeOnSelect="false"
            class="multiselect-theme"
            size="30"
            @change="onChange($event, 'file')"
            v-model="designation"
          >
            <template v-slot:option="{ option }">
              {{ option.role_Name }}
            </template>
          </Multiselect>
        </div>
      </div>
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
                <input type="checkbox" id="selectall" @change="selectall()" />
                Name
              </th>
              <th v-for="permissions in permissionList" :key="permissions.id">
                <input
                  type="checkbox"
                  :id="permissions.permission"
                  @change="setpermissions(permissions.permission)"
                />
                {{ permissions.permission }}
              </th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="options in userList" :key="options.id">
              <td>
                <input
                  v-if="userobject[options.userID]"
                  type="checkbox"
                  :value="options.name"
                  :id="options.userID"
                  :checked="
                    userobject[options.userID] &&
                    Array.isArray(userobject[options.userID].permission) &&
                    userobject[options.userID].permission.length > 0
                  "
                  @change="setcontrols(options)"
                />
                {{ options.name }}
              </td>
              <td v-for="option in permissionList" :key="option.id">
                <input
                  v-if="userobject[options.userID]"
                  type="checkbox"
                  :value="option.permission"
                  :class="options.id"
                  v-model="userobject[options.userID].permission"
                  @change="selectuserwithpermission(options.userID)"
                />
                {{ option.permission }}
              </td>
              <td class="text-center">
                <button
                  class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative"
                  type="button"
                  @click="saveSinglePermission('file', options.userID)"
                  :disabled="loadingPermission[options.userID] == true"
                  :class="{
                    'disabled-btn-cls':
                      loadingPermission[options.userID] == true,
                  }"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': loadingPermission[options.userID] == false,
                      'opacity-1': loadingPermission[options.userID] == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <p
                    class="mb-0"
                    :class="{
                      'opacity-1': loadingPermission[options.userID] == false,
                      'opacity-0': loadingPermission[options.userID] == true,
                    }"
                  >
                    {{ $t("navigations.save") }}
                  </p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between"
        v-if="selectedRole.length != 0 && userList.length != 0"
      >
        <p class="my-0">
          *Unsaved changes will be lost if switching designations.
        </p>
        <button
          type="button"
          @click="multiSavePermission('file')"
          class="save_btn py-1 px-3 position-relative"
          :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingSaveModalBtn == false,
              'opacity-1': loadingSaveModalBtn == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <p
            class="mb-0"
            :class="{
              'opacity-1': loadingSaveModalBtn == false,
              'opacity-0': loadingSaveModalBtn == true,
            }"
          >
            {{ $t("navigations.save") }}
          </p>
        </button>
      </div>
    </template>
  </customModal>
   <customModal v-if="openPermissionModal==true" :containermd=true :footerShow=true @closeModal="permissionModalClose">
    <template #title>
      {{ $t("navigations.folder permission") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
            <label for="chooseFolderRole">Designations</label>
            <Multiselect
              name="designation"
              id="chooseFolderRole"
              valueProp="id"
              mode="multiple"
              placeholder="Select"
              :options="roleList"
              :hideSelected="false"
              :closeOnSelect="false"
              class="multiselect-theme"
              size="30"
              @change="onChange($event,'folder')"
              v-model="designation"
            > <template v-slot:option="{ option }">
                {{ option.role_Name }}
              </template>
            </Multiselect>
        </div>
      </div>  
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  id="selectall"
                  @change="selectall()"
                />
                Name
              </th>
              <th
                v-for="permissions in permissionList"
                :key="permissions.id"
              >
                <input
                  type="checkbox"
                  :id="permissions.permission"
                  @change="setpermissions(permissions.permission)"
                />
                {{ permissions.permission }}
              </th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="options in userList" :key="options.id">
              <td>
                <input v-if="userobject[options.userID]"
                  type="checkbox"
                  :value="options.name"
                  :id="options.userID"
                  :checked="
                      userobject[options.userID] &&
                      Array.isArray(userobject[options.userID].permission) &&
                      userobject[options.userID].permission.length > 0
                  "
                  @change="setcontrols(options)"
                />
                {{ options.name }}
              </td>
              <td v-for="option in permissionList" :key="option.id">
                <input  v-if="userobject[options.userID]"
                  type="checkbox"
                  :value="option.permission"
                  :class="options.id"
                  v-model="userobject[options.userID].permission"
                  @change="selectuserwithpermission(options.userID)"
                />
                {{ option.permission }}
              </td>
              <td class="text-center">
                <button  @click="saveSinglePermission('folder',options.userID)" class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative" type="button" :disabled="loadingPermission[options.userID] == true"
                  :class="{ 'disabled-btn-cls': loadingPermission[options.userID] == true }">
                  <div class="toc-loader position-absolute"
                  :class="{ 'opacity-0': loadingPermission[options.userID] == false, 'opacity-1': loadingPermission[options.userID] == true }">
                  <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                  </div>
                  <p class="mb-0" :class="{ 'opacity-1': loadingPermission[options.userID] == false, 'opacity-0': loadingPermission[options.userID] == true }">{{
                  $t("navigations.save") }}</p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-between" v-if="selectedRole.length!=0 && userList.length!=0">
        <p class="my-0"> *Unsaved changes will be lost if switching designations.</p>
        <button type="button" @click="multiSavePermission('folder')" class="save_btn py-1 px-3 position-relative" :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }">
          <div class="toc-loader position-absolute"
          :class="{ 'opacity-0': loadingSaveModalBtn == false, 'opacity-1': loadingSaveModalBtn == true }">
          <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
          </div>
          <p class="mb-0" :class="{ 'opacity-1': loadingSaveModalBtn == false, 'opacity-0': loadingSaveModalBtn == true }">{{
          $t("navigations.save") }}</p>
        </button>
      </div>
    </template>
  </customModal>
  <customModal
    v-if="uploadDocumentModal == true"
    :containermd="true"
    @closeModal="uploadDocumentModalClose"
  >
    <template #title>
      <span v-if="documentEdit == false">{{
        $t("navigations.upload document")
      }}</span>
      <span v-else>{{ $t("navigations.edit document") }}</span>
    </template>
    <template #body>
      <div v-if="documentEdit == false">
        <div class="row">
          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="document title">Document Title</label>
            <input
              placeholder="Enter document title"
              type="text"
              id="document-title"
              v-model="docTitle"
              class="form-control"
              maxlength="75"
            />
          </div>
          <div class="col-12 col-md-6 mt-2">
            <label id="version">Version</label>
            <input
              placeholder="Enter version"
              type="text"
              for="version"
              v-model="this.docVersion"
              class="form-control"
              maxlength="10"
              :readonly="documentEdit == true"
            />
          </div>
          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="documentOwner">Select Owner</label>
            <select
              id="documentOwner"
              v-model="documentUploadFields.owner"
              class="mr-3 form-select form-select-lg"
            >
              <option
                v-for="(users, index) in ownerList"
                :key="index"
                :value="`${users.firstName} ${users.lastName}`"
              >
                {{ `${users.firstName} ${users.lastName}` }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-6 mt-2">
            <label id="expiry-date">Expiry Date</label>
            <input
              placeholder="Select a date "
              for="expiry-date"
              type="text"
              v-model="documentUploadFields.expiryDate"
              class="form-control"
              onfocus="(type='date')"
              onblur="(type='text')"
              maxlength="30"
            />
            <span
              class="d-block errorClass"
              v-if="documentValidationsError[1] == true"
            >
              Please enter a future date
            </span>
          </div>
          <div class="col-12 mt-2">
            <label id="description">Description</label>
            <textarea
              placeholder="Enter description"
              id="description"
              class="form-control"
              v-model="documentUploadFields.description"
              maxlength="250"
            ></textarea>
          </div>
          <div class="col-12 mt-2">
            <label id="changesHistory">Changes History</label>
            <textarea
              placeholder="Enter changes history"
              id="changesHistory"
              class="form-control"
              v-model="documentUploadFields.changesHistory"
              maxlength="250"
            ></textarea>
          </div>
          <!-- <div
          v-if="documentUploadFields.documentType.trim() != ''"
          class="col-12 mt-2 form-check"
        >
          <input
            class="form-check-input"
            v-model="addsigner"
            type="checkbox"
            @change="createbookmarkuserarray()"
            value=""
            id="flexCheckDefault"
          />
          <label class="form-check-label ml-4" for="flexCheckDefault">
            Do you need to add signer ?
          </label>
        </div> -->
          <!-- <div class="col-12 mt-2" v-if="addsigner">
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Signing order
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Bookmark/Role
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    User
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(bookmarks, index) in bookmarklist"
                :key="bookmarks"
              >
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ bookmarklist[index].bookmarkName }}
                </td>
                <td>
                  <select
                    id="user"
                    class="mr-3 form-select form-select-lg"
                    aria-label=".form-select-lg example"
                    :disabled="
                      index != 0 &&
                      bokkmarkusersarray[index - 1].userID == ''
                    "
                    @change="assignbookmarkuserfun($event, index)"
                  >
                    <option value="" selected disabled>
                      --Select a User--
                    </option>
                    <option
                      v-for="users in signuserList"
                      :value="
                        users.id + ',' + users.email + ',' + users.name
                      "
                      :key="users.id"
                    >
                      {{ users.name }}
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
          <div class="col-12 mt-2">
            <input
              accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx,.doc"
              id="InPutFile"
              type="file"
              class="form-control d-none my-2 my-md-0"
              @change="previewFiles"
              multiple
            />
            <div
              class="input-group"
              v-for="(eachfiles, index) in list"
              :key="eachfiles"
            >
              <div class="listfile breakWord">
                <a>
                  {{ eachfiles.name }}
                  <i class="fa fa-close" @click.prevent="removefile(index)"></i
                ></a>
              </div>
            </div>
            <span class="errorClass" v-if="documentValidationsError[2] == true">
              Please upload a file
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <button
            class="browser-btn py-1 px-3 mr-2"
            type="button"
            @click="loadfile()"
          >
            <p class="mb-0">{{ $t("navigations.browse") }}</p>
          </button>
          <button
            type="button"
            @click="submitFile()"
            class="save_btn py-1 px-3 position-relative"
            :disabled="loadingDocUpload == true"
            :class="{ 'disabled-btn-cls': loadingDocUpload == true }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': loadingDocUpload == false,
                'opacity-1': loadingDocUpload == true,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <p
              class="mb-0"
              :class="{
                'opacity-1': loadingDocUpload == false,
                'opacity-0': loadingDocUpload == true,
              }"
            >
              {{ $t("navigations.save") }}
            </p>
          </button>
        </div>
      </div>
      <div v-else>
        <div class="text-center" v-if="documentLoader == true">
          <h4>{{ `Please wait while the data is being fetched` }}</h4>
          <img
            src="../../assets/img/loading.gif"
            width="15"
            alt="Waiting for login"
          />
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12 col-md-6 pr-md-1 mt-2">
              <label for="document title">Document Title</label>
              <input
                placeholder="Enter document title"
                type="text"
                id="document-title"
                v-model="docTitle"
                class="form-control"
                maxlength="75"
              />
            </div>
            <div class="col-12 col-md-6 mt-2">
              <label id="version">Version</label>
              <input
                placeholder="Enter version"
                type="text"
                for="version"
                v-model="this.docVersion"
                class="form-control"
                maxlength="10"
                :readonly="documentEdit == true"
              />
            </div>
            <div class="col-12 col-md-6 pr-md-1 mt-2">
              <label for="documentOwner">Select Owner</label>
              <select
                id="documentOwner"
                v-model="documentUploadFields.owner"
                class="mr-3 form-select form-select-lg"
              >
                <option
                  v-for="(users, index) in ownerList"
                  :key="index"
                  :value="`${users.firstName} ${users.lastName}`"
                >
                  {{ `${users.firstName} ${users.lastName}` }}
                </option>
              </select>
            </div>
            <div class="col-12 col-md-6 mt-2">
              <label id="expiry-date">Expiry Date</label>
              <input
                placeholder="Select a date "
                for="expiry-date"
                type="text"
                v-model="documentUploadFields.expiryDate"
                class="form-control"
                onfocus="(type='date')"
                onblur="(type='text')"
                maxlength="30"
              />
              <span
                class="d-block errorClass"
                v-if="documentValidationsError[1] == true"
              >
                Please enter a future date
              </span>
            </div>
            <div class="col-12 mt-2">
              <label id="description">Description</label>
              <textarea
                placeholder="Enter description"
                id="description"
                class="form-control"
                v-model="documentUploadFields.description"
                maxlength="250"
              ></textarea>
            </div>
            <div class="col-12 mt-2">
              <label id="changesHistory">Changes history</label>
              <textarea
                placeholder="Enter changes history"
                id="changesHistory"
                class="form-control"
                v-model="documentUploadFields.changesHistory"
                maxlength="250"
              ></textarea>
            </div>
            <!-- <div
          v-if="documentUploadFields.documentType.trim() != ''"
          class="col-12 mt-2 form-check"
        >
          <input
            class="form-check-input"
            v-model="addsigner"
            type="checkbox"
            @change="createbookmarkuserarray()"
            value=""
            id="flexCheckDefault"
          />
          <label class="form-check-label ml-4" for="flexCheckDefault">
            Do you need to add signer ?
          </label>
        </div> -->
            <!-- <div class="col-12 mt-2" v-if="addsigner">
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Signing order
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Bookmark/Role
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    User
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(bookmarks, index) in bookmarklist"
                :key="bookmarks"
              >
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ bookmarklist[index].bookmarkName }}
                </td>
                <td>
                  <select
                    id="user"
                    class="mr-3 form-select form-select-lg"
                    aria-label=".form-select-lg example"
                    :disabled="
                      index != 0 &&
                      bokkmarkusersarray[index - 1].userID == ''
                    "
                    @change="assignbookmarkuserfun($event, index)"
                  >
                    <option value="" selected disabled>
                      --Select a User--
                    </option>
                    <option
                      v-for="users in signuserList"
                      :value="
                        users.id + ',' + users.email + ',' + users.name
                      "
                      :key="users.id"
                    >
                      {{ users.name }}
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
            <div class="col-12 mt-2">
              <input
                accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx,.doc"
                id="InPutFile"
                type="file"
                class="form-control d-none my-2 my-md-0"
                @change="previewFiles"
                multiple
              />
              <div
                class="input-group"
                v-for="(eachfiles, index) in list"
                :key="eachfiles"
              >
                <div class="listfile breakWord">
                  <a>
                    {{ eachfiles.name }}
                    <i
                      class="fa fa-close"
                      @click.prevent="removefile(index)"
                    ></i
                  ></a>
                </div>
              </div>
              <span
                class="errorClass"
                v-if="documentValidationsError[2] == true"
              >
                Please upload a file
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <button
              class="browser-btn py-1 px-3 mr-2"
              type="button"
              @click="loadfile()"
            >
              <p class="mb-0">{{ $t("navigations.browse") }}</p>
            </button>
            <button
              type="button"
              @click="submitFile()"
              class="save_btn py-1 px-3 position-relative"
              :disabled="loadingDocUpload == true"
              :class="{ 'disabled-btn-cls': loadingDocUpload == true }"
            >
              <div
                class="toc-loader position-absolute"
                :class="{
                  'opacity-0': loadingDocUpload == false,
                  'opacity-1': loadingDocUpload == true,
                }"
              >
                <img
                  src="../../assets/img/loading.gif"
                  width="15"
                  class="loading-btn-img"
                  alt="Waiting for login"
                />
              </div>
              <p
                class="mb-0"
                :class="{
                  'opacity-1': loadingDocUpload == false,
                  'opacity-0': loadingDocUpload == true,
                }"
              >
                {{ $t("navigations.save") }}
              </p>
            </button>
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>
<script>
/* eslint-disable */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @uploadlibactive="uploadpopupmodal = false"
import moment from "moment";
import axios from "axios";
import store from "../../store/index";
import AddApproverLibrary from "../AddApproverLibrary/AddApproverLibrary.vue";
import TreeWithNewpopup from "../TreeWithNewpopup/TreeWithNewpopup.vue";
import TreeMove from "../TreeMove/TreeMove.vue";
import listApproverPopup from "../listApprover/listApproverPopup.vue";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
// import VPagination from "@hennge/vue3-pagination";
import DocumentPopup from "../uploaddocumentpopup/uploaddocumentpopup.vue";
export default {
  props: { userid: String, siteCode: String },
  data() {
    return {
      reloaddocfolders: true,
      documentUploadFields: {
        folderid: "",
        documentIdd: "",
        title: "",
        description: "",
        owner: "",
        department: "",
        category: "",
        standard: "",
        documentType: "",
        version: "",
        expiryDate: "",
        formData: "",
        changesHistory: "",
      },
      azuredata: {
        DocumentId: "",
        DocumentVersionId: "",
        DocumentTypeName: "",
        DocumentTitle: "",
        DocumentDescription: "",
        Document: [],
        OrganizationId: 2,
        Approver: [],
      },
      documentValidationsError: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      addsigner: false,
      savefolder: false,
      roleprivileges: "",
      fileuploadurl: process.env.VUE_APP_File_upload_URL + "/document",
      baseurl: process.env.VUE_APP_Service_URL,
      baseapi: process.env.VUE_APP_Service_URL,
      folderlist: [],
      list: [],
      loaddata: false,
      versionNumber: "",
      values: {
        FolderName: "",
        AncestorIds: [],
        Approver: [],
        ParentId: "",
        storageId: "",
      },
      approveList: [],
      approverlist: "",
      retrieve: true,
      updateFolder: {
        id: "",
        folderName: "",
        ancestorIds: [],
        parentId: "",
        storageId: "",
      },
      folderbyid: {},
      errors: [],
      validations: [],
      showFolder: false,
      showDoc: false,
      showTableLoading: false,
      xlsFile: "",
      docTitle: "",
      docVersion: "",
      getfolderbyids: {},
      doclist: "",
      currentUser: "",
      docsId: "",
      documentName: "",
      documentById: "",
      docversioncount: "",
      parentFolderId: "",
      ShowDocName: true,
      totalPage: 1,
      currentPage: 1,
      totalCount: 0,
      pageindex: 1,
      uploadpopupmodal: false,
      pagesize: 10,
      storagevalue: "",
      SortProperty: "CreatedAt",
      SortOrder: 1,
      bold: "",
      office: ["xls", "xlsx", "doc", "docx"],
      format: "",
      source: "",
      officeurl: "",
      isEditable: false,
      showFilter: false,
      dropdownOpen: false,
      showDocLoading: false,
      showFolderInfoLoading: false,
      changedFlag: false,
      showTreeLoading: true,
      editFolderModal: false,
      loadingGenerateBtn: false,
      uploadDocumentModal: false,
      loadingDocUpload: false,
      loadingEditFolder: false,
      loadingCloneFolder: false,
      openPermissionModal: false,
      openDocsPermissionModal: false,
      openFolderShareModal: false,
      loadingSaveModalBtn: false,
      anyuserpermissions: false,
      initialDocDownloader: false,
      openFileShareModal: false,
      initialLoader: false,
      openFileViewModal: false,
      documentLoader: false,
      showSelectTemplate: false,
      documentEdit: false,
      hasChild: false,
      initialTreeDownloader: false,
      initialPermissionLoader: false,
      showDocLoading: [false],
      editFolderErrors: [false, false, false, false],
      loadingPermission: {},
      folderErrorMessages: ["Please enter a folder name"],
      selectedcolumnobj: {},
      selectedFolderswitch: {},
      userobject: {},
      getLatestVersionMsg: "",
      getDocumentData: {},
      SelectedFormat: [],
      ownerList: [],
      readMore: [false],
      readTitleMore: [false],
      selectedTemplate: "",
      openfolderlist: "",
      FormatList: [],
      documentList: [],
      categorylist: [],
      departmentlist: [],
      roleList: [],
      permissionList: [],
      designation: [],
      selectedRole: [],
      source: "",
      folderType: "",
      selectedDocument: "",
      doctypelist: [],
      standards: [],
      userList: [],
      templateList: [],
      lastAncestor: "",
      studyInfo: {},
      sendtoValue: "",
      permissionsValue: "",
      shareValue: "",
      editValue: "",
      artifactId: "",
      deleteValue: "",
      archiveValue: "",
      downloadValue: "",
      viewValue: "",
      process: "",
      selectedFolderValue: "",
      cloneFolderModal: "",
      cloneType: "",
      location: "",
      newFolderName: "",
      prefix: "",
      majorVerStart: "",
      minorVerStart: "",
      minorVermax: "",
      folderidbyparentid:"",
    };
  },
  components: {
    // VPagination,A
    DocumentPopup,
    AddApproverLibrary,
    listApproverPopup,
    TreeWithNewpopup,
    TreeMove,
    Multiselect,
    customModal,
  },
   async mounted() {
    let previousroute = store.getters.getPrevRoute;
    if(previousroute == "documentview"){
    this.openfolderlist = store.getters.getnewopenfolderlist || [];
    }
   
    await this.getTemplateList()
    await this.getStudyTemplateValue()
    await this.getTree()
    await this.setroleprivileges()
    this.defaultdate = localStorage.getItem("dateformat")
    this.getstudyinfo();
    await this.restoreLastSelectedFolder();
    window.addEventListener("studyIdChanged", async () => {
      this.folderType = ""
      this.isEditable = false
      this.selectedTemplate = ""
      this.hasChild = false
      this.folderlist = []
      this.showSelectTemplate = false
      await this.getstudyinfo()
      await this.getStudyTemplateValue()
      this.getreviewers();
      await this.getTree()
      await this.setroleprivileges();
      await this.getDocuments()
      await this.restoreLastSelectedFolder();
    })
  },
  // async mounted() {
  //   this.getreviewers();
  //   this.getTree();
  //   await this.setroleprivileges();
  //   await this.getDocuments();
  // },
  async beforeMount() {
    await store.dispatch("setFolderName", null);
    await store.dispatch("setFolderdate", null);
    this.getfolder(this.userid);
    store.dispatch("setDetails", false);
    const folderId = store.getters.getFolderId;
    const folderName = store.getters.getFolderName;
    const lastModifiedAt = store.getters.getFolderdate;
    const storageId = store.getters.getStorageId;
    const storageCode = store.getters.getStorageCode;
    this.filter();
  },
  watch: {
    $route(to, from) {
      this.previousRouteName = from?.name || null
      console.log('prevRoute', from)
    },
    routePath(newPath, oldPath) {
      console.log('route changed:', { from: oldPath, to: newPath })
    },
    "$store.getters.getFolderId": function (newVal) {
      this.bold = newVal;
    },
  },
  computed: {
    showDetails() {
      return store.getters.getDetails;
    },
    folderNames() {
      this.setgetdetails();
      return store.getters.getFolderName;
    },
    lastModifiedAt() {
      return store.getters.getFolderdate;
    },
     routePath() { return this.$route.fullPath }
  },
  methods: {
    async restoreLastSelectedFolder() {
  var studyId = store.getters.getStudyIs;
  var key = "lastFolderId:" + studyId;
  var lastId = null;

  try { lastId = localStorage.getItem(key); } catch (e) { lastId = null; }
  if (!lastId) return;

  // Make sure the tree is rendered before we try to click nodes
  await this.$nextTick();

  try {
    // Use your existing helper to expand ancestors & reveal the node
    await this.getfolderslastancestor(lastId);

    // Ensure the store knows which folder is active (in case the click didn’t fire)
    store.dispatch("setFolderId", lastId);

    // Optional: load docs right away
    this.getDocuments();
  } catch (e) {
    // If the saved folder isn’t valid for this study anymore, just ignore
  }
},

    clickedOut(e) {
      if (e.relatedTarget.id === "primary-tmf-tree") {
        store.dispatch("setFolderId", "");
      }
    },
    async setData() {
      // this.getDocumentData.expiryDate != null
      //   ? (this.getDocumentData.expiryDate = this.getDocumentData.expiryDate.slice(0, 10))
      //   : this.getDocumentData.expiryDate;
      this.docFolder = this.getDocumentData.folderId;
      this.docTitle = this.getDocumentData.documentTitle;
      this.documentUploadFields.description =
        this.getDocumentData.documentDescription != null
          ? this.getDocumentData.documentDescription
          : "";
      this.documentUploadFields.owner = this.getDocumentData.owner;
      // this.documentUploadFields.Department = this.getDocumentData.department;
      // this.documentUploadFields.Category = this.getDocumentData.catagory;
      // this.documentUploadFields.Standard = this.getDocumentData.standard;
      // this.documentUploadFields.documenttype = this.getDocumentData.documentType;
      this.docVersion = this.getDocumentData.latestVersion;
      this.documentUploadFields.expiryDate = this.getDocumentData.expiryDate
        ? this.getDocumentData.expiryDate.slice(0, 10)
        : "";
      this.documentUploadFields.changesHistory =
        this.getDocumentData.changeHistory;
    },
     async getTemplateList() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/gettmftemplates`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.templateList = res.data
        })
        .catch((err) => {
          console.log(err);
        });
    },
     async getstudyinfo() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/study/getbyid?id=${store.getters.getStudyIs}&api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studyInfo = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getFolderChildrens(id) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/getprivilegedchildren?Id=${id}&StudyId=${store.getters.getStudyIs}&condition=site`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.length != 0) {
            if (res.data[0].type) {
              this.folderType = res.data[0].type;
            }
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    openDocumentModal() {
      this.uploadDocumentModal = true;
      this.getStudyBasedUsers();
    },
      async getStudyTemplateValue() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/isetmfgenerated?studyid=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((res) => {
          console.log("ressssssssss",res.data)
          if(res.data==true){
            this.showSelectTemplate=false
          }
          else{
            this.showSelectTemplate=true
          }
       
      })
      .catch((err) => {
        console.log(err)
       
      })

    },
    async getTree() {
      //this.showTreeLoading = true
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/getprivilegedroots?storageType=General&StudyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.showTreeLoading = false;
          this.folderlist = res.data;

          if (this.folderlist.length != 0) {
            this.showSelectTemplate = false;
            const rootFolder = this.folderlist.find(
              (item) => item.type === "Root"
            );
            if (rootFolder) {
              this.parentFolderId = rootFolder.id;
              this.getFolderChildrens(rootFolder.id);
            }
          } else {
            this.parentFolderId = "";
            this.showSelectTemplate = true;
          }
        })
        .catch((err) => {
          this.showTreeLoading = false;
          console.log(err.response.data.messages);
        });
    },
    async getfolderslastancestor(id) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/getfolderbyid?Id=${id}&StudyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          let editedfolderdetails = [];
          editedfolderdetails = res.data.ancestorIds;
          this.lastAncestor =
            editedfolderdetails[editedfolderdetails.length - 1];
          if (this.lastAncestor != "" && this.lastAncestor != undefined) {
            document.getElementById("etmf-" + this.lastAncestor).click();
            document.getElementById("etmf-" + this.lastAncestor).click();
            document.getElementById("etmf-" + res.data.id).click();
          } else {
            this.lastAncestor = "";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async archiveFolder() {
      const folderId = store.getters.getFolderId;
      if (
        confirm(
          this.$t("navigations.are you sure you want to archive this folder")
        )
      ) {
        const idtoken = store.getters.getIdToken;
        await axios
          .put(
            `${this.baseurl}/etmf/folder/archivefolder?id=${folderId}&StudyId=${store.getters.getStudyIs}`,
            {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            alert(this.$t("navigations.folder archived successfully"));
            this.getfolderslastancestor(store.getters.getFolderId);
            if (this.lastAncestor == "") {
              this.folderlist.forEach((element) => {
                if (element.id == store.getters.getFolderId) {
                  let index = this.folderlist.indexOf(element);
                  this.folderlist.splice(index, 1);
                }
              });
            }
          })
          .catch((err) => {
            if (
              err.response.data.messages[0].includes(
                "This folder contains 1 or more subfolders, folder with subfolders cannot be deleted"
              )
            ) {
              alert(
                this.$t(
                  "navigations.this folder contains 1 or more subfolders, folder with subfolders cannot be deleted"
                )
              );
            }
            if (
              err.response.data.messages[0].includes(
                "This folder contains 1 or more documents, folder with document cannot be deleted"
              )
            ) {
              alert(
                this.$t(
                  "navigations.this folder contains 1 or more documents, folder with document cannot be deleted"
                )
              );
            }
          });
      }
    },
    openCloneFolder(name) {
      this.newFolderName = name;
      this.cloneFolderModal = true;
    },
    showTitleLess(index) {
      this.readTitleMore[index] = false;
    },
    async openSidePopup(id) {
      this.showDocLoading[id] = true;
      this.selectedDocument = id;
      await this.getDocumentdetails(id);
    },
    async exportFolder(name) {
      this.process = "exported";
      this.initialLoader = true;
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/exportfolder?exportfolderId=${folderId}&StudyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          const contentDisposition = res.headers["content-disposition"];
          let fileName = `${name}.zip`;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1]);
            }
          }

          // Create a link and trigger the download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          alert(this.$t("navigations.folder exported successfully"));
          this.initialLoader = false;
        })
        .catch((err) => {
          this.initialLoader = false;
          console.error("err", err);
        });
    },
    async getDocuments() {
      console.log("calling getdocuments function");
      this.documentList = [];
      const idtoken = store.getters.getIdToken;
      this.showTableLoading = true;
      
      if (store.getters.getFolderId != "") {
        await axios
          .get(
            `${this.baseurl}/etmf/folder/getprivilegedcontent?Id=${this.folderidbyparentid}&StudyId=${store.getters.getStudyIs}&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.showTableLoading = false;
            this.documentList = res.data;
            if (this.documentList != null && this.documentList.length != 0) {
              this.documentList.forEach((item) => {
                this.showDocLoading[item.id] = false;
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.showTableLoading = false;
          });
      } else {
        this.showTableLoading = false;
        this.documentList = [];
      }
    },
    async getDocumentdetails(id) {
      this.sendtoValue = "";
      this.editValue = "";
      this.permissionsValue = "";
      this.shareValue = "";
      this.deleteValue = "";
      this.archiveValue = "";
      this.viewValue = "";
      this.deleteValue = "";
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${id}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.document.userPermission[0].permission!= null) {
            this.anyuserpermissions = false;

            res.data.document.userPermission[0].permission.forEach((item) => {
              if (item == "View") this.viewValue = item;
              if (item == "Clone") this.sendtoValue = item;
              if (item == "Permissions") this.permissionsValue = item;
              if (item == "Share") this.shareValue = item;
              if (item == "Edit") this.editValue = item;
              if (item == "Delete") this.deleteValue = item;
              if (item == "Archive") this.archiveValue = item;
              if (item == "Download") this.downloadValue = item;
            });
            if (
              !this.viewValue ||
              !this.sendtoValue ||
              !this.permissionsValue ||
              !this.shareValue ||
              !this.editValue ||
              !this.deleteValue ||
              !this.archiveValue ||
              !this.downloadValue
            ) {
              this.anyuserpermissions = true;
            }
          } else {
            this.anyuserpermissions = true;
          }
          this.showDocLoading[id] = false;
          // this.getVersionHistory();
        })
        .catch((err) => {
          this.showDocLoading[id] = false;
          console.log(err);
        });
    },
    async addFolderPermission(type, id, documentId) {
      await this.closePopover(id);
      this.initialPermissionLoader = true;
      this.selectedDocument = documentId;
      this.source = type;
      this.designation = [];
      this.userList = [];
      this.selectedRole = [];
      this.userobject = {};
      await this.listRoles();
      if (this.source == "File") {
        this.initialPermissionLoader = false;
        this.openDocsPermissionModal = true;
        await this.getAllFilePermission();
      } else {
        this.initialPermissionLoader = false;
        this.openPermissionModal = true;
        await this.getAllFolderPermission();
      }
    },
    async shareFolderPermission(type, id, docId) {
      let documentId = id;

      this.initialPermissionLoader = true;
      this.source = type;
      this.designation = [];
      this.userList = [];
      this.selectedRole = [];
      this.userobject = {};
      this.selectedDocument = docId;
      await this.listRoles();
      this.source = type;
      if (this.source == "File") {
        await this.closePopover(id);
        this.initialPermissionLoader = false;
        this.documentIdd = documentId.replace("tmf-docs-", "");
        this.openFileShareModal = true;
        await this.getAllFilePermission();
      } else {
        this.initialPermissionLoader = false;
        this.openFolderShareModal = true;
        await this.getAllFolderPermission();
      }
    },
     async getAllFilePermission() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folderfilepermission/allfilepermission`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.permissionList = res.data;
          this.setofpermissions();
        })
        .catch((err) => {
          console.log(err);
        });
    },
       setofpermissions() {
      this.permissionList.forEach((permissions) => {
        this.permissionset.push(permissions.permission);
      })
    },
     async getDesignationUser(type,docId) {
      const idtoken = store.getters.getIdToken;
      await axios
        .post(`${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`,
          type == 'Permission' ? this.selectedRole : [],
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.userList = res.data;
          if (type == 'Permission') {
            this.setUsersInArray();
            this.getAllPermissions();
            this.getPermissionById(docId);
          }

        })
        .catch((err) => {
          console.log(err);
        });
    },
       async setUsersInArray() {
      this.userobject = [];
      this.userList.forEach((eachusers) => {
        if (this.source == 'File') {
          let userinformations = {
            "permissionType": "Designation",
            "permissionId": eachusers.roleId,
            "userId": eachusers.userID,
            "emailId": eachusers.email,
            "name": eachusers.name,
            "permission": [],
            "userName": eachusers.userName
          };
          this.loadingPermission[eachusers.userID] = false
          this.userobject[eachusers.userID] = userinformations;
        }
        else {
          let userinformations = {
            "permissionType": "Designation",
            "permissionId": eachusers.roleId,
            "userId": eachusers.userID,
            "emailId": eachusers.email,
            "name": eachusers.name,
            "permission": [],
            "userName": eachusers.userName
          };
          this.loadingPermission[eachusers.userID] = false
          this.userobject[eachusers.userID] = userinformations; ``
        }

      });
    },
    async listRoles() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/account-core/roles/search?`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (
            res.data.data != null &&
            res.data.data != undefined &&
            res.data.data.length != 0
          ) {
            this.roleList = res.data.data.sort((a, b) =>
              a.role_Name.localeCompare(b.role_Name)
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    addFolderModalClose() {
      this.values.FolderName = "";
      this.showFolder = false;
      this.editFolderErrors = [false, false, false, false];
    },
    async multiSaveShare(type) {
      const idtoken = store.getters.getIdToken;
      this.source = type;
      this.loadingSaveModalBtn = true;
      if (type == "Folder") {
        let savedata = {
          folderId: store.getters.getFolderId,
          type: this.source,
          department: "",
          studyId: store.getters.getStudyIs,
          userPermission: Object.values(this.userobject),
        };

        await axios
          .post(`${this.baseurl}/etmf/folder/sharefolder`, savedata, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            this.userListsss = res.data;
            alert("Folder shared successfully");
            this.loadingSaveModalBtn = false;
            this.closeShareFolderPermission();
          })
          .catch((err) => {
            console.log(err);
            this.loadingSaveModalBtn = false;
          });
      } else {
        let savedata = {
          documentId: this.selectedDocument,
          version: "",
          studyId: store.getters.getStudyIs,
          type: type,
          department: "",
          userlist: Object.values(this.userobject),
        };
        await axios
          .post(`${this.baseurl}/etmf/document/sharedocument`, savedata, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            this.userListsss = res.data;
            alert("Document shared successfully");
            this.loadingSaveModalBtn = false;
            this.closeShareFolderPermission("File");
          })
          .catch((err) => {
            console.log(err);
            this.loadingSaveModalBtn = false;
          });
      }
    },
     async archiveDocument(id, documentId) {
      await this.closePopover(id)
      const idtoken = store.getters.getIdToken;
     if(confirm(this.$t('navigations.are you sure you want to archive this document')))
      {
        await axios
          .put(
            `${this.baseurl}/etmf/document/archivedocument?id=${documentId}`, {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            alert(this.$t('navigations.document archived successfully'))
            this.getDocuments()
          })
          .catch((err) => {
            console.log(err);
            this.showTableLoading = false
          });
      }
    },
    closeShareFolderPermission(type) {
      if (type == "File") {
        this.openFileShareModal = false;
      } else {
        this.openFolderShareModal = false;
      }
    },
    async closeViewDocumentModal(id, name) {
      this.openFileViewModal = false;
      this.format = "";
      this.source = "";
      this.documentName = "";
    },
    permissionModalClose(type) {
      if (type == "File") {
        this.openDocsPermissionModal = false;
      } else {
        this.openPermissionModal = false;
      }
    },


    async getAllFolderPermission() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folderfilepermission/allfolderpermission`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.permissionList = res.data;
          this.setofpermissions();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openDocumentModal() {
      this.uploadDocumentModal = true;
    },
    returnChild(value) {
      this.hasChild = value;
    },
    async setDoc(id) {
      this.source = `${this.baseurl}/etmf/document/getdocument?documentId=${id}`;
      this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${this.source}`;
    },
    async downloadDocument(id, documentId, name) {
      await this.closePopover(documentId);
      const res = await fetch(
        `${this.baseurl}/etmf/document/getdocument?documentId=${id}`
      );
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = name; // this will now be respected
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      alert(this.$t("navigations.document downloaded successfully"));
    },
    async exportTreeFolderStructure(name) {
      this.initialTreeDownloader = true;
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/gettmffolderstructure/${folderId}?folderName=${name}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "text/plain",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let fileName = `${name}.xlsx`; // fallback filename
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          alert(this.$t("navigations.folder exported successfully"));
          this.initialTreeDownloader = false;
        })
        .catch((err) => {
          this.initialTreeDownloader = false;
          console.error("err", err);
        });
    },
    async callartifactfun(){
      let reloadfolder = true;
      const idtoken = store.getters.getIdToken;
      let folderid = store.getters.getFolderId;
      let studyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/getfolderidbyparentid?studyId=${studyid}&parentId=${folderid}&name=${this.siteCode}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,

              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("response is............", res.data);
          this.folderidbyparentid = res.data;
          this.documentPopupId = res.data;
          this.getDocuments();
        })
        .catch((err) => {
          alert(this.$t("navigations.document is not available"));
          console.log(err);
        });
    },
      selectedtype(type){
        console.log("type in folder", type);
      },
    returnFolderType(value) {
      if(value == null || value == ""){
        console.log("this might be an artifact");
        this.callartifactfun();
      }
      this.folderType = value;
      let folderid = store.getters.getFolderId;
      this.documentPopupId = folderid;
      console.log("type is", this.folderType, "and folderid is",folderid);
      if (this.folderType != "" && this.folderType != undefined) {
        this.isEditable = false;
      } else {
        this.isEditable = true;
      }
    },

    async uploadmethodactivity() {
      this.uploadpopupmodal = false;
      this.documentType =""
      await this.callartifactfun();
      await this.getDocuments();
    },
     async saveSinglePermission(type, id) {
      this.loadingPermission[id] = true
      const idtoken = store.getters.getIdToken;
      if (type == 'folder') {
        let savedata = {
          "folderId": store.getters.getFolderId,
          "userPermission": this.userobject[id]
        };
        await axios
          .post(`${this.baseurl}/etmf/folderfilepermission/singlesavefolder`, savedata
            , {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            this.loadingPermission[id] = false
            alert("Permission added successfully");
          })
          .catch((err) => {
            this.loadingPermission[id] = false
            console.log(err);
          });
      }
      else {
        let savedata = {
          "documentId": this.selectedDocument,
          "userPermission": this.userobject[id]
        };
        await axios
          .post(`${this.baseurl}/etmf/folderfilepermission/singlesavefile`, savedata
            , {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            this.loadingPermission[id] = false
            alert("Permission added successfully");
          })
          .catch((err) => {
            this.loadingPermission[id] = false
            console.log(err);
          });
      }


    },
    async enablepopup(editorcreate) {
      this.calldetails = editorcreate;
      this.documentPopupId = 0;
      this.doceditid = 0;
      this.Description = "";
      this.artifactId =store.getters.getFolderId;
      this.documentType ="site"
      this.uploadpopupmodal = true;
    },
    async setgetdetails() {
      if (store.getters.getFolderName) {
        this.savefolder = true;
      } else {
        this.savefolder = false;
      }
    },
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
     async createFolderfunc(value) {
      this.values.FolderName = ""
      this.values.Approver = [];
      if(store.getters.getFolderId==''){
        this.folderType=""
        this.isEditable=true
      }
      else if (this.folderType != '' && this.folderType != undefined ) {
        this.isEditable = false
      }
      if (value == "addRoot" || value == 'addSubFolder') {
        this.folderbyid.name = ""
        this.selectedFolderValue = "addRoot"
        this.showFolder = !this.showFolder;
      }
    },
    async createFolder(value) {
      this.values.FolderName = "";
      this.values.Approver = [];
      if (store.getters.getFolderId == "") {
        this.folderType = "";
        this.isEditable = true;
      } else if (this.folderType != "" && this.folderType != undefined) {
        this.isEditable = false;
      }
      if (value == "addRoot" || value == "addSubFolder") {
        this.folderbyid.name = "";
        this.selectedFolderValue = "addRoot";
        this.showFolder = !this.showFolder;
      }
    },
    async hideorshow(elid) {
      const list = document.getElementsByClassName("tree" + elid).classList;
      console.log("classlist is ----------------------------------------");
      console.log(list);
    },
    async previewFiles(event) {
      this.azuredata.Document = event.target.files[0];
      console.log("upload file is", this.azuredata.Document.name);
    },
    filter(data) {
      if (data) {
        return moment(data).format("DD/MM/YYYY");
      }
    },
    loadPage: function (page) {
      this.currentPage = page;
      this.pageindex = page;
      this.getDocuments();
    },
    click() {
      console.log("clickkkkk", this.azuredata.DocumentDescription);
      if (this.azuredata.DocumentDescription != null) {
        this.azuredata.DocumentDescription = "";
        console.log("entered clickk");
      }
    },
    async AddApproverPopuup(doc, versionId, versionNumber, approvallength) {
      console.log("in approval popup function");
      console.log(approvallength.length);
      this.documentPopupId = doc;
      this.PopupVersionId = versionId;
      this.PopupVersionNumber = versionNumber;
      console.log("Hellooooiii", doc, versionId, approvallength);
      if (approvallength.length == 0 || approvallength == null) {
        console.log("approval list is " + approvallength);
        this.popactive = true;
      } else {
        this.popupmodal = true;
      }
    },
    async getdmsdocument() {
      console.log("document download", this.Document);
      await axios
        .get(
          `${this.fileuploadurl}/getallfiles/${this.Document.documentReferenceId}`,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,

              "Content-Type": "application/json",
              responseType: "blob",
            },
          }
        )
        .then((res) => {
          this.documentById = res.data;
          console.log("Docdownld............", this.documentById);
        })
        .catch((err) => {
          alert(this.$t("navigations.document is not available"));
          console.log(err);
        });
    },
    async downloadfile(docId) {
      this.ShowDocName = false;
      await this.getDocumentById(docId);
      //await this.getdmsdocument(docId);
      const fileName =
        this.Document.documentVersions[
          this.Document.documentVersions.length - 1
        ].documentVersionId;
      // const filename = this.documentById.documentVersions[0].fileName;
      // console.log("filename", filename);
      var a = document.createElement("a");
      a.href = `${this.fileuploadurl}/document/file/${this.Document.documentReferenceId}?versionid=${fileName}`;
      a.download = "FILENAME";
      a.click();
    },

    SortSelected(sortProp, id) {
      console.log("SortPropChanged", sortProp);
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      this.getDocuments();
    },
    async getreviewers() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/forms/digitalform/getapprovalusers`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log(res);
          this.approverlist = res.data;

          console.log("Reviewers", this.approverlist);
        })
        .catch((err) => {
          console.log(err);
        });
    },
async editDocument(documentId, id, version) {
      await this.closePopover(id)
      this.documentEdit = true
      this.uploadDocumentModal = true
      this.documentLoader = true
      await this.getStudyBasedUsers()
      await this.getDocumentDetails(documentId, version)
      this.documentLoader = false

    },
     uploadDocumentModalClose() {
      this.list = []
      this.uploadDocumentModal = false
      this.documentEdit = false
      this.docTitle = ""
      this.docVersion = ""
      this.azuredata.Document = []
      this.documentValidationsError = [false, false, false]
      this.documentUploadFields = {
        folderid: "",
        title: "",
        description: "",
        owner: "",
        department: "",
        category: "",
        standard: "",
        documentType: "",
        version: "",
        expiryDate: "",
        formData: "",
        changesHistory: "",
      }
    },
       async validatedocument() {
      this.documentValidationsError = [false, false, false];

      if (store.getters.getFolderId.trim() == "") {
        this.documentValidationsError[0] = true;
        this.loadingDocUpload = false
      }

      if (this.azuredata.Document.length === 0 && this.documentEdit == false) {
        this.documentValidationsError[2] = true;
        this.loadingDocUpload = false
      }
      if (this.documentUploadFields.expiryDate != null) {
        if (new Date(this.documentUploadFields.expiryDate) < new Date()) {
          this.documentValidationsError[1] = true;
          this.loadingDocUpload = false
        }
      }

    },
    async submitFile() {
      const idtoken = store.getters.getIdToken;
      this.loadingDocUpload = true
      let vervalue = this.docVersion.toString();
      await this.validatedocument();
      if (!this.documentValidationsError.includes(true)) {
        if (this.documentEdit == false) {
         const uploadPromises = this.list.map(async (eachfiles) => {
            if (eachfiles.size == 0) {
              alert("Blank documents cannot be uploaded");
              this.loadingDocUpload = false
            } else {
              if (this.docTitle.trim() == "") {
                this.documentUploadFields.title = eachfiles.name;
              }
              if(this.documentUploadFields.owner.trim() == ""){
                this.documentUploadFields.owner = this.currentUser;
              }
              if (this.docTitle.trim() != "") {
                this.documentUploadFields.title = this.docTitle;
              }
              if (vervalue.trim() == "") {
                vervalue = "1";
              }
              const formData = new FormData();
              formData.append("DocumentDescription", this.documentUploadFields.description);
              formData.append("StudyId", store.getters.getStudyIs);
              formData.append("FolderId", store.getters.getFolderId ? store.getters.getFolderId.trim() : "");
              formData.append("File", eachfiles); // this is critical
              formData.append("Owner", this.documentUploadFields.owner);
              formData.append("ExpiryDate", this.documentUploadFields.expiryDate);
              formData.append("Version", vervalue ? vervalue.trim() : "");
              formData.append("DocumentTitle", this.documentUploadFields.title ? this.documentUploadFields.title.trim() : "");
              formData.append("VersionMessage", this.documentUploadFields.changesHistory);
              formData.append("StorageLocation", "TMF");
                return axios.post(
                    `${this.baseurl}/etmf/document/uploaddocument`,
                    formData,
                    {
                      headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "multipart/form-data",
                      },
                    }
                  );
            }
          })
      

            this.loadingDocUpload = true;

            try {
              await Promise.all(uploadPromises);
              alert(this.$t("navigations.documents saved successfully"))
              this.uploadDocumentModalClose();
              this.getDocuments();
            } catch (err) {
              alert(err.message || "Failed to upload one or more documents.");
            } finally {
              this.loadingDocUpload = false;
            }
        }
        else {
          if (this.azuredata.Document != "") {
            if (confirm("Are you sure you want to replace the existing file?")) {
              await axios
                .put(
                  `${this.baseurl}/etmf/document/editdocument`,
                  {
                    "documentId": this.selectedDocument,
                    "folderId": store.getters.getFolderId,
                    "documentTitle": this.docTitle,
                    "documentDescription": this.documentUploadFields.description,
                    "changeHistory": this.documentUploadFields.changesHistory,
                    "owner": this.documentUploadFields.owner,
                    "department": "",
                    "catagory": "",
                    "standard": "",
                    "documentType": "",
                    "expiryDate": this.documentUploadFields.expiryDate ? this.documentUploadFields.expiryDate : null,
                    "currentVersion": vervalue,
                    "isDeleted": false,
                    "status": "string",
                    "versionMessage": this.documentUploadFields.changesHistory,
                    "signers": [
                      {
                        "bookmark": "string",
                        "signOrder": "string",
                        "userId": "string",
                        "userEmail": "string",
                        "date": "2025-05-27T05:51:56.555Z",
                        "signId": "string",
                        "reason": "string",
                        "userName": "string",
                        "isSigned": true,
                        "signedDocId": "string"
                      }
                    ],
                    "studyId": store.getters.getStudyIs,
                    "artifactId": store.getters.getFolderId,
                    "effectiveDate": "2025-05-27T05:51:56.555Z",
                    "author": "",
                    "reviewDate": "2025-05-27T05:51:56.555Z",
                    "approvalDate": "2025-05-27T05:51:56.555Z",
                    "siteId": "",
                    "country": "",
                    "language": "",
                    "product": "",
                    "region": "",
                    "fileSize": "",
                    "checksum": ""
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((res) => {
                  this.replaceFile()
                  alert("Document updated successfully");
                  this.uploadDocumentModalClose()
                  this.getDocuments()
                  this.loadingDocUpload = false

                })
                .catch((err) => {
                  this.loadingDocUpload = false
                });
            } else {
              this.loadingDocUpload = false
              return;
            }
          } else {
            await axios
              .put(
                `${this.baseurl}/etmf/document/editdocument`,
                {
                  "documentId": this.selectedDocument,
                  "folderId": store.getters.getFolderId,
                  "documentTitle": this.docTitle,
                  "documentDescription": this.documentUploadFields.description,
                  "changeHistory": this.documentUploadFields.changesHistory,
                  "owner": this.documentUploadFields.owner,
                  "department": "",
                  "catagory": "",
                  "standard": "",
                  "documentType": "",
                  "expiryDate": this.documentUploadFields.expiryDate ? this.documentUploadFields.expiryDate : null,
                  "currentVersion": vervalue,
                  "isDeleted": false,
                  "status": "",
                  "versionMessage": "",
                  "signers": [
                    {
                      "bookmark": "string",
                      "signOrder": "string",
                      "userId": "string",
                      "userEmail": "string",
                      "date": "2025-05-27T05:51:56.555Z",
                      "signId": "string",
                      "reason": "string",
                      "userName": "string",
                      "isSigned": true,
                      "signedDocId": "string"
                    }
                  ],
                  "studyId": store.getters.getStudyIs,
                  "artifactId": store.getters.getFolderId,
                  "effectiveDate": "2025-05-27T05:51:56.555Z",
                  "author": "",
                  "reviewDate": "2025-05-27T05:51:56.555Z",
                  "approvalDate": "2025-05-27T05:51:56.555Z",
                  "siteId": "",
                  "country": "",
                  "language": "",
                  "product": "",
                  "region": "",
                  "fileSize": "",
                  "checksum": ""
                },
                {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                alert("Document updated successfully");
                this.uploadDocumentModalClose()
                this.getDocuments()
                this.loadingDocUpload = false
              })
              .catch((err) => {
                this.loadingDocUpload = false
              });
          }

        }
      }
    },

    async getStudyBasedUsers(type) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/account-core/user/getstudybasedusers?studyid=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (
            res.data.entities != null &&
            res.data.entities != undefined &&
            res.data.entities.length != 0
          ) {
            this.ownerList = res.data.entities.sort((a, b) =>
              a.firstName.localeCompare(b.firstName)
            );
          }
          this.setCurrentUser(this.ownerList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async GetDocumentDetailsfoUpdate(docId) {
      this.calldetails = "edit";
      this.createFolderfunc("uploadDoc");
      this.ShowDocName = true;
      await this.getDocumentById(docId);
      console.log("fjfffffffffff", this.Document);
      this.azuredata.DocumentDescription = this.Document.documentDescription;
      this.azuredata.DocumentName = this.Document.documentName;
      this.azuredata.DocumentId = this.Document.documentReferenceId;
      this.documentPopupId = this.Document.documentReferenceId;
      this.doceditid = docId;
      this.Description = this.azuredata.DocumentDescription;
      console.log("idddddddddd is", docId);
    },
    async onclosed(value) {
      this.azuredata.DocumentDescription = "";
      this.values.Approver = [];
      this.values.FolderName = "";
      document.body.style.overflowY = "auto";
      if (value == "addFolder") {
        this.showFolder = false;
      } else this.showDoc = false;
    },
    async getDocumentById(docId) {
      this.currentdocId = docId;
      console.log("docccccccccccccc..", docId);
      console.log("docccccccccccccc..", this.currentdocId);
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/document/getdocumentbyid?id=` + docId,
          //  `https://localhost:5001/document/getdocumentbyid?id=`+ docId,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.Document = res.data;
          this.loaddata = true;
          this.documentName = this.Document.documentName;
        });
    },
    async multiSavePermission(type) {
      this.loadingSaveModalBtn = true
      if (type == 'folder') {
        let savedata = {
          "folderId": store.getters.getFolderId,
          "userPermission": Object.values(this.userobject)
        };
        if (savedata.userPermission.length != 0) {
          const idtoken = store.getters.getIdToken;
          await axios
            .post(`${this.baseurl}/etmf/folderfilepermission/multiplesavefolder`, savedata
              , {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              })
            .then((res) => {
              this.userListsss = res.data;
              this.loadingSaveModalBtn = false
              alert("Permission added successfully");
              this.permissionModalClose();
            })
            .catch((err) => {
              this.loadingSaveModalBtn = false
              console.log(err);
            });
        }
      }
      else {
        let savedata = {
          "documentId": this.selectedDocument,
          "userPermission": Object.values(this.userobject)
        };
        if (savedata.userPermission.length != 0) {
          const idtoken = store.getters.getIdToken;
          await axios
            .post(`${this.baseurl}/etmf/folderfilepermission/multiplesavefile`, savedata
              , {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              })
            .then((res) => {
              this.userListsss = res.data;
              this.loadingSaveModalBtn = false
              alert("Permission added successfully");
              this.permissionModalClose('File');
            })
            .catch((err) => {
              this.loadingSaveModalBtn = false
              console.log(err);
            });
        }
      }
    },
    async viewDocument(id, name, version) {
      this.$router.push(`/documentview/${id}/${version}`);
    },
    // async viewDocument(docId) {
    //   this.ShowDocName = false;
    //   await this.getDocumentById(docId);
    //   //await this.getdmsdocument(docId);
    //   const versionId =
    //     this.Document.documentVersions[
    //       this.Document.documentVersions.length - 1
    //     ].documentVersionId;

    //   const filename =
    //     this.Document.documentVersions[
    //       this.Document.documentVersions.length - 1
    //     ].fileName;
    //   this.$router.push(
    //     `/documentview/${this.Document.documentReferenceId}/${versionId}`
    //   );
    // },
    async deleteAzureDocument(docId) {
      const idtoken = store.getters.getIdToken;
      this.ShowDocName = false;
      console.log("get doc to delete", this.currentdocId);
      await this.getDocumentById(docId);
      console.log("value", this.Document.documentReferenceId);
      if (
        confirm(
          this.$t("navigations.are you sure you want to delete this document?")
        )
      ) {
        await axios
          .delete(
            `${this.baseurl}/management/document/delete?id=${this.Document.documentReferenceId}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log(response.data);
            alert(this.$t("navigations.document deleted successfully"));
            this.deleteDocument(docId);
          })
          .catch((err) => {
            console.log("nope", err);
          });
      }
    },
     async closePopover(id) {
      document.getElementById(id) ? document.getElementById(id).hidePopover() : null
    },
    async deleteDocument(documentId, id) {
      await this.closePopover(id)
      const idtoken = store.getters.getIdToken;
      if (confirm(this.$t('navigations.are you sure you want to delete this document'))) {
        await axios
          .delete(`${this.baseurl}/etmf/document/deletedocument?documentId=${documentId}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            alert(this.$t('navigations.document deleted successfully'))
            this.getDocuments()
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    async validateDocumentIsNull() {
      if (this.azuredata.Document != "") {
        this.validations[2] = true;
      } else {
        this.validations[2] = false;
      }
    },
    async getDocumentDetails(documentId, version) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${documentId}&version=${version}`,

          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.getDocumentData = res.data;
          this.currentVersion = this.getDocumentData.currentVersion;
          if (res.data.latestVersionInfo != null) {
            this.getLatestVersionMsg =
              res.data.latestVersionInfo[
                res.data.latestVersionInfo.length - 1
              ].versionMessage;
            this.latestver =
              res.data.latestVersionInfo[
                res.data.latestVersionInfo.length - 1
              ].version;
          }

          this.setData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async closebutton() {
      console.log("CLOSE MODEL");
      this.errors[1] = true;
      this.retrieve = true;
    },
    getupdatedfolder(id) {
      this.folderlist = [];
      console.log("helooooooo", id);
      const idtoken = store.getters.getIdToken;
      axios
        .get(`${this.baseurl}/management/folder/listfolder?storageId=${id}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.folderlist = res.data;
        });
    },
    async getfolder(id) {
      this.folderlist = [];
      console.log("helooooooo", id);
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/management/folder/listfolder?storageId=${id}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.folderlist = res.data;
        });
    },
    async updateFolderName() {
      this.retrieve = false;
      this.updateFolder.folderName = this.folderNames;
    },
    async validateIsNull() {
      if (this.values.FolderName == "") {
        this.validations[0] = false;
        this.errors = this.validations;
      } else if (this.values.FolderName.trim("") == "") {
        this.validations[0] = false;
        this.errors = this.validations;
      } else {
        this.validations[0] = true;
        this.errors = this.validations;
      }
    },
    //   async updatefolder(name, type) {
    //   this.loadingEditFolder = true
    //   const folderId = store.getters.getFolderId;
    //   const idtoken = store.getters.getIdToken;
    //   this.updateFolder.id = folderId;
    //   this.updateFolder.ancestorIds = this.folderbyid.ancestorIds;
    //   this.updateFolder.parentId = this.folderbyid.parentId;
    //   this.updateFolder.storageId = "General";
    //   await this.validate();
    //   if (!this.editFolderErrors.includes(true)) {
    //     await axios
    //       .put(`${this.baseurl}/etmf/folder/updatefolder?Id=${folderId}`,
    //         {
    //           "name": this.updateFolder.folderName,
    //           "storageId": "string",
    //           "storageType": this.updateFolder.storageId,
    //           "fileConfiguration": [
    //             "string"
    //           ],
    //           "versionConfiguration": [
    //             {
    //               "prefix": this.prefix,
    //               "majorVerStart": this.majorVerStart,
    //               "minorVerStart": this.minorVerStart,
    //               "minorVermax": this.minorVermax
    //             }
    //           ],
    //           "studyId": store.getters.getStudyIs,
    //           "type": this.folderType
    //         }, {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       })
    //       .then((res) => {
    //         alert(this.$t("navigations.folder updated successfully"));
    //         this.loadingEditFolder = false
    //         this.editFolderModalClose();
    //         this.getfolderslastancestor(store.getters.getFolderId);
    //         if (this.lastAncestor == "") {
    //           this.folderlist.forEach((element) => {
    //             if (element.id == store.getters.getFolderId) {
    //               element.name = name
    //             }
    //           });
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //         this.loadingEditFolder = false
    //         alert(this.$t("navigations.folder name already exist"));
    //       });
    //   }
    // },
    updateFolderNameInTree(folderId, updatedName) {
      const updateName = (list) => {
        if (!list || !Array.isArray(list)) return;
        for (const item of list) {
          if (item.id === folderId) {
            item.name = updatedName;
            return;
          }
          if (item.children) {
            updateName(item.children);
          }
        }
      };
      for (const key in this.folderlist) {
        updateName(this.folderlist[key]);
      }
    },

    async validateNameIsNull() {
      if (this.updateFolder.folderName == "") {
        this.validations[1] = false;
        this.errors = this.validations;
      } else if (this.updateFolder.folderName.trim("") == "") {
        this.validations[1] = false;
        this.errors = this.validations;
      } else {
        this.validations[1] = true;
        this.errors = this.validations;
      }
    },
      editFolderModalClose() {
      this.editFolderModal = false
      this.loadingEditFolder = false
      this.folderType = ""
      this.folderbyid.name = ""
      this.editFolderErrors = [false, false, false, false]
    },
     cloneFolderModalClose() {
      this.cloneFolderModal = false
      this.cloneType = ""
      this.newFolderName = ""
      store.dispatch("setFolderMoveId", "");
    },
      async cloneFolder() {
      const folderMoveId = store.getters.getFolderMoveId;
      const folderId = store.getters.getFolderId
      if (this.cloneType == '' || store.getters.getFolderMoveId == '') {
        if (this.cloneType == '') {
          alert(this.$t('navigations.please choose an action before clone'))
        }
        if (store.getters.getFolderMoveId == '') {
          alert(this.$t('navigations.please choose an target folder before clone'))
        }
      }
      else {
        if (
          confirm(
            this.$t("navigations.are you sure you want to clone this folder")
          )
        ) {
          const idtoken = store.getters.getIdToken;
          this.loadingCloneFolder = true
          await axios
            .get(
              `${this.baseurl}/etmf/folder/copyfolder?FolderId=${folderId}&TargetId=${folderMoveId}&NewName=${this.newFolderName}&CloneType=${this.cloneType}&StudyId=${store.getters.getStudyIs}`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              this.loadingCloneFolder = false
              alert(this.$t("navigations.folder cloned successfully"));
              if (this.selectedFolderswitch[folderMoveId]) {
                document.getElementById("etmf-" + folderMoveId).click();
                document.getElementById("etmf-" + folderMoveId).click();
              }
              else {
                document.getElementById("etmf-" + folderMoveId).click();
              }
              this.cloneFolderModalClose()
            })
            .catch((err) => {
              this.loadingCloneFolder = false
              if (
                err.response.data ==
                "Subfolder with new name exist in targeted folder"
              ) {
                alert(
                  this.$t("navigations.subfolder with new name exist in targeted folder")
                );
              }
              if (
                err.response.data == "Subfolder with same name exist in targeted folder") {
                alert(
                  this.$t("navigations.subfolder with same name exist in targeted folder")
                );
              }
              if (
                err.response.data ==
                "Cannot move folder inside itself"
              ) {
                alert(
                  this.$t("navigations.cannot move folder inside itself")
                );
              }

            });
        }
      }

    },
   async getFolderbyId() {
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/getfolderbyid?Id=${folderId}&StudyId=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.folderbyid = res.data;
          this.folderType = res.data.type
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async trim() {
      this.values.FolderName = this.values.FolderName.replace(
        /^\s+|\s+$/gm,
        ""
      );
    },
    // async addFolder() {
    //   const idtoken = store.getters.getIdToken;
    //   const folderId = store.getters.getFolderId;
    //   const storageId = store.getters.getStorageId;
    //   this.values.storageId = storageId;
    //   await this.validateIsNull();
    //   if (this.errors[0]) {
    //     if (this.savefolder == false) {
    //       this.values.ParentId = "";
    //       this.values.storageId = this.userid;
    //       this.values.AncestorIds = [];
    //       this.trim();
    //       await axios
    //         .post(`${this.baseurl}/management/folder/create`, this.values, {
    //           headers: {
    //             Authorization: "Bearer " + idtoken,
    //             "Content-Type": "application/json",
    //           },
    //         })
    //         .then((res) => {
    //           console.log(res);
    //           alert(this.$t("navigations.folder created successfully"));
    //           this.showFolder = false;
    //           this.values.FolderName = "";
    //           document.body.style.overflowY = "auto";
    //           this.getupdatedfolder(this.userid);
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //           alert(this.$t("navigations.folder name already exist"));
    //         });
    //     } else {
    //       this.addSubFolder();
    //     }
    //     this.loadingEditFolder = false;
    //     this.addFolderModalClose();
    //   }
    // },
    async addSubFolder() {
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      const storageId = store.getters.getStorageId;
      await this.getFolderbyId(folderId);
      this.values.ParentId = folderId;
      this.values.storageId = storageId;
      this.values.AncestorIds = [folderId];
      this.folderbyid.ancestorIds.forEach((element) => {
        const index = this.folderbyid.ancestorIds.indexOf(element);
        this.values.AncestorIds[index + 1] = this.folderbyid.ancestorIds[index];
      });
      await this.validateIsNull();
      if (this.errors[0]) {
        this.trim();

        await axios
          .post(
            `${this.baseurl}/management/folder/create`,
            this.values,

            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            console.log(res);
            alert(this.$t("navigations.folder created successfully"));
            this.showFolder = false;
            this.values.FolderName = "";
            document.body.style.overflowY = "auto";
            this.getfolder(this.userid);
          })
          .catch((err) => {
            console.log(err);
            alert(this.$t("navigations.folder name already exist"));
          });
      }
    },
    async editFolder(id) {
      this.editFolderModal = true
      this.getFolderbyId()
    },
    async addFolder(type) {
      const idtoken = store.getters.getIdToken;
      let folderId = store.getters.getFolderId;
      this.loadingEditFolder = true
      await this.validate();
      if (this.selectedFolderValue == 'addRoot') {
        if (!this.editFolderErrors.includes(true)) {
          await axios
            .post(`${this.baseurl}/etmf/folder/createtmffolder`, {
              "name": this.updateFolder.folderName,
              "studyName": this.studyInfo.studyName,
              "parentId": folderId ? folderId : this.parentFolderId ? this.parentFolderId : '',
              "storageId": "",
              "storageType": "General",
              "fileConfiguration": this.SelectedFormat,
              "versionConfiguration": [
                {
                  "prefix": this.prefix,
                  "majorVerStart": this.majorVerStart,
                  "minorVerStart": this.minorVerStart,
                  "minorVermax": this.minorVermax
                }],
              "ancestorIds": [
                "string"
              ],
              "studyId": store.getters.getStudyIs,
              "type": this.folderType
            }, {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              alert(this.$t("navigations.folder created successfully"));
              this.getStudyTemplateValue();
               this.getTree();
              store.dispatch("setFolderId", folderId);
              if (folderId) {
                document.getElementById("etmf-" + folderId).click();
                document.getElementById("etmf-" + folderId).click();
              }
              else {
                this.getTree()
              }
              this.addFolderModalClose()
              this.loadingEditFolder = false

            })
            .catch((err) => {
              this.loadingEditFolder = false
              console.log(err.response);
              if (err.response && err.response.data.errors && err.response.data.errors.DomainValidations[0] == 'Folder name already present in the parent folder.') {
                alert(this.$t('navigations.folder name already present in the parent folder'))
              }
            });
        }
      }
    },
     async validate() {
      this.editFolderErrors = [false, false, false]
      this.updateFolder.folderName = this.folderbyid.name ? this.folderbyid.name.replace(/ +/g, ' ').trim() : ''
      this.folderType = this.folderType ? this.folderType.replace(/ +/g, ' ').trim() : ''
      if (this.updateFolder.folderName == "") {
        this.editFolderErrors[0] = true;
        this.folderErrorMessages[0] = "Please enter a folder name";
        this.loadingEditFolder = false
      }
      else if (this.updateFolder.folderName.length > 75) {
        this.editFolderErrors[0] = true;
        this.folderErrorMessages[0] = "Maximum number of character is 75";
        this.loadingEditFolder = false
      }
      if (this.hasChild == false && this.folderType == "") {
        this.editFolderErrors[1] = true;
        this.loadingEditFolder = false
      }
    },
    async updatefolder(name, type) {
      this.loadingEditFolder = true
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      this.updateFolder.id = folderId;
      this.updateFolder.ancestorIds = this.folderbyid.ancestorIds;
      this.updateFolder.parentId = this.folderbyid.parentId;
      this.updateFolder.storageId = "General";
      await this.validate();
      if (!this.editFolderErrors.includes(true)) {
        await axios
          .put(`${this.baseurl}/etmf/folder/updatefolder?Id=${folderId}`,
            {
              "name": this.updateFolder.folderName,
              "storageId": "string",
              "storageType": this.updateFolder.storageId,
              "fileConfiguration": [
                "string"
              ],
              "versionConfiguration": [
                {
                  "prefix": this.prefix,
                  "majorVerStart": this.majorVerStart,
                  "minorVerStart": this.minorVerStart,
                  "minorVermax": this.minorVermax
                }
              ],
              "studyId": store.getters.getStudyIs,
              "type": this.folderType
            }, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            alert(this.$t("navigations.folder updated successfully"));
            this.loadingEditFolder = false
            this.editFolderModalClose();
            this.getfolderslastancestor(store.getters.getFolderId);
            if (this.lastAncestor == "") {
              this.folderlist.forEach((element) => {
                if (element.id == store.getters.getFolderId) {
                  element.name = name
                }
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.loadingEditFolder = false
            alert(this.$t("navigations.folder name already exist"));
          });
      }
    },
      async onChange(event, type) {
      console.log(event, type)
      this.showSave = true
      if (type == 'file' || type == 'folder') {
        this.selectedRole = event;
      }
      else {
        this.selectedRole[0] = event.target.value;
      }

      if (event.length != 0) {
        await this.getDesignationUser('Permission',type)
        this.permissionset = [];
      }
      else {
        this.userList = []
      }
    },
    async setcontrols(elements) {
      let checkBox = document.getElementById(elements.userID);
      if (checkBox.checked == true) {
        this.userobject[elements.userID].permission = this.permissionset;

      } else {
        if (elements.userID in this.userobject) {
          this.userobject[elements.userID].permission = [];
        }
      }
    },
    async selectall() {
      let checkBoxall = document.getElementById("selectall");
      if (checkBoxall.checked == true) {
        this.userList.forEach((users) => {
          this.userobject[users.userID].permission = this.permissionset;
        })
      } else {
        this.userList.forEach((users) => {
          this.userobject[users.userID].permission = [];
        })
      }
    },

   async deleteFolder(ancestorIds) {
      const folderId = store.getters.getFolderId;
      if (
        confirm(
          this.$t("navigations.are you sure you want to delete this folder?")
        )
      ) { if (
          confirm(
             this.$t("navigations.all the folders and documents under this folder will be deleted")
          )
        ) {
        const idtoken = store.getters.getIdToken;
        this.initialLoader = true
        this.process = "deleted"
        await axios
          .delete(
            `${this.baseurl}/etmf/folder/deletefolder?Id=${folderId}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            alert(this.$t("navigations.folder deleted successfully"));
            if (ancestorIds.length === 0) {
              store.dispatch("setFolderId", "");
            } else {
              this.lastAncestor = ancestorIds.pop();
              store.dispatch("setFolderId", this.lastAncestor);
            }
            this.folderlist.forEach((element) => {
              if (element.id == folderId) {
                let index = this.folderlist.indexOf(element);
                this.folderlist.splice(index, 1);
              }
            });
            if(this.folderlist.length==0){
              this.parentFolderId=""
              this.showSelectTemplate=true
              this.selectedTemplate=""
              this.folderType=""
              this.isEditable=false
            }
            document.getElementById("etmf-" + this.lastAncestor).click();
            document.getElementById("etmf-" + this.lastAncestor).click();
            store.dispatch("setFolderId", "");
            this.initialLoader = false
          })
          .catch((err) => {
            this.initialLoader = false
            console.log(err)
          })
        }
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "../../assets/formpage.css";
.linkstyle {
  cursor: pointer;
}
.form-control1 {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.428571;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn-danger1 {
  color: #fff;
  background-color: #ed5565;
  border-color: #ed5565;
  position: relative;
  width: 70px;
  height: 30px;
  padding: 3px 0;
  border-radius: 30px;
  text-align: center;
  font-size: 15px;
  line-height: 1.428571429;
  border: 0px solid #bb458f;
}
.btn-infos {
  color: #fff;
  background-color: #23c6c8;
  border-color: #23c6c8;
  position: relative;
  width: 70px;
  height: 30px;
  padding: 3px 0;
  border-radius: 30px;
  text-align: center;
  font-size: 15px;
  line-height: 3.428571;
  border: 0 solid #bb458f;
}
.closetooltipposition {
  bottom: -10px !important;
  margin-left: -70px !important;
}
.btn-xs1 {
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
}
.btnnew {
  border-radius: 3px;
  font-size: inherit;
  padding: 6px;
}
.edit-delete,
.edit-delete:hover {
  color: var(--primary-color) !important;
  cursor: pointer !important;
  font-size: 18px;
}
/*pagination styles*/
.pagination {
  margin: 0;
}
.Page,
.PaginationControl {
  border: 1px solid #e7eaec;
}
.modal__wrapper1 {
  position: fixed;
  left: 0;
  top: 0;
  background: rgb(0 0 0 / 18%);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: cubic-bezier;
  overflow: scroll;
}
.Page-active {
  padding: .6rem;
  color: #ffffff;
  border: 1px solid var(--pagination-active-clr);
  border-radius: inherit;
  margin: 0;
}
.Page {
  padding: .6rem;
  border-radius: inherit;
  margin: 0;
}
.PaginationControl {
  padding: 0.07rem;
}
.close-block {
  opacity: 0.5;
  font-weight: 700;
  font-size: 0.8rem !important;
}
.title-class {
  background-color: #618bd7;
}
.title-class > * {
  color: #ffffff;
}
.create-folder-modal {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}
.folder-modal-container {
  background: #fff;
  width: min(40%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.position-relative {
  position: relative;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -35px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.position-relative:hover .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
.blank-wrapper{
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  color:rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
  pointer-events: auto;
}
.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
.overflow-y-block {
  overflow-y: auto;
  max-height: calc(100dvh - 200px)
}
.overflow-y-modal {
  overflow-y: auto;
  max-height: 300px
}

.more-block,
.less-block {
  font-size: 11px;
  color: #618bd7;
}

.fixed-width-table-cell{
  max-width: 65ch;
  text-wrap: auto;
}
.browser-btn{
  border: 1px solid #e7eaec;
  background-color: #e7eaec;
  border-radius: 0.25rem;
}

.height-scroll
{
  height: 250px;
  overflow-y: auto;
}
/* CSS Popover Styles */

.tmf-doc-ellipsis-btn{
    anchor-name:--manage-btn;
    border:0;
 }
  .tmf-docs-popup-menu {
    position:absolute;
    inset: auto;
    text-align: left;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
  }
  .tmf-docs-popup-menu{
    top:anchor(bottom);
    right:anchor(left);
    width:fit-content;
    margin-inline-end: 5px;
  }
  .tmf-docs-popup-menu{
    position-try-fallbacks: --bottom;
    top:anchor(bottom);
    right:anchor(right);
    width:160px;
  }
  .tmf-docs-popup-menu> button{
    width:100%;
    border:0;
    font-size:0.8rem;
    font-weight:400;
    color:rgba(0,0,0);
    padding: 0.6rem 0.8rem;
  }

  [popover]:popover-open {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    animation: fadeIn 0.2s ease-in-out;
  }

  .tmf-docs-popup-menu> .popup-menu-block:hover, .popup-submenu> div:hover{
    background-color: #e4eaf9;
  }

  @position-try --bottom{
    inset:auto;
    bottom:anchor(top);
    right:anchor(left)
  }
/* CSS Popover Styles */
.fixed-header th {
  top: 0px;
  position: -webkit-sticky;
  position: sticky;
  background-color: #fff;
}
.field-validation {
  font-size: 0.4rem;
  color: hsl(0, 100%, 50%);
}
.iframe-wrapper {
  width: 100%;
  height: calc(100vh - 80px); /* adjust if you have header/navbar */
}

.docusign-frame {
  width: 100%;
  height: 100%;
  border: none;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
/* CSS Popover Styles */

.tmf-doc-ellipsis-btn{
    anchor-name:--manage-btn;
    border:0;
 }
  .tmf-docs-popup-menu {
    position:absolute;
    inset: auto;
    text-align: left;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
  }
  .tmf-docs-popup-menu{
    top:anchor(bottom);
    right:anchor(left);
    width:fit-content;
    margin-inline-end: 5px;
  }
  .tmf-docs-popup-menu{
    position-try-fallbacks: --bottom;
    top:anchor(bottom);
    right:anchor(right);
    width:160px;
  }
  .tmf-docs-popup-menu> button{
    width:100%;
    border:0;
    font-size:0.8rem;
    font-weight:400;
    color:rgba(0,0,0);
    padding: 0.6rem 0.8rem;
  }

  [popover]:popover-open {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    animation: fadeIn 0.2s ease-in-out;
  }

  .tmf-docs-popup-menu> .popup-menu-block:hover, .popup-submenu> div:hover{
    background-color: #e4eaf9;
  }

  @position-try --bottom{
    inset:auto;
    bottom:anchor(top);
    right:anchor(left)
  }
/* CSS Popover Styles */
</style>
